import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from "next/link";
import { memo } from "react";
import { Routes } from "~/constants/routes";
import { formatFullName } from "~/utils/formatFullName";
export const PublicTopBarDesktopAccountInfo = /*#__PURE__*/ memo((param)=>{
    let { account: { lastName, firstName, email }, canCreateAccount } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ _jsxs("p", {
                "data-testid": "PUBLIC_TOP_BAR_ACCOUNT_NAME",
                className: "truncate text-16 text-grey-10",
                children: [
                    formatFullName(firstName, lastName),
                    " (",
                    email,
                    ")"
                ]
            }),
            canCreateAccount && /*#__PURE__*/ _jsx(Link, {
                "data-testid": "PUBLIC_TOP_BAR_CREATE_ACCOUNT_LINK",
                className: "text-14 font-semibold text-grey-10 hover:underline",
                href: "".concat(Routes.auth.signUp, "?email=").concat(encodeURIComponent(email)),
                children: "Create account"
            })
        ]
    });
});
PublicTopBarDesktopAccountInfo.displayName = "PublicTopBarAccountInfo";
